module.exports = __webpack_public_path__ + "img/icon_3_33.f4957cfa.png";